var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"not-found"}},[_c('h3',[_vm._v("Error 404: What you're looking for is not here...")])])
}]

export { render, staticRenderFns }